<script setup lang="ts">
import { reactive, onUnmounted } from "vue";
import {
  SupportedEaseNameToCubicBezier,
  transitionStart$,
  transitionEnd$
} from "@zyzgroup/core-web";
import Box from "./Box.vue";

// css-transition 渐变属性 : 某个属性 从 指定的开始状态 过渡到 特定的结束状态
// 一次性 + 不可暂停 + 不可反转

// transition: 属性名称 duration timing-function delay

// 属性名称:
// all
// width
// height
// border-width
// color
// background-color
// border-color
// text-decoration-color
// fill
// stroke
// opacity
// box-shadow
// transform
// filter
// backdrop-filter

// timing-function:
// linear
// ease
// ease-in
// ease-in-out
// ease-out
// cubic-bezier(0.25, 0.1, 0.25, 1)

export type SupportedCSSTransition = "superRainbow";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    name?: SupportedCSSTransition;
    duration?: number;
    timingFunction?: SupportedEaseNameToCubicBezier;
    delay?: number;
  }>(),
  {
    name: "superRainbow",
    duration: 300,
    timingFunction: "ease-out",
    delay: 0
  }
);

const emits = defineEmits<{
  (event: "csstransitionstart", e: TransitionEvent): void;
  (event: "csstransitionend", e: TransitionEvent): void;
}>();

const style = reactive<Record<string, string>>({
  cursor: "pointer"
  // willChange: "box-shadow, transform",
  // transition: `transform ${props.duration}ms ease-in-out, box-shadow ${props.duration}ms ease-in-out`
});

let s1;
let s2;
const mount = (box) => {
  s1 = transitionStart$(box.el).subscribe((e) => {
    emits("csstransitionstart", e);
  });
  s2 = transitionEnd$(box.el).subscribe((e) => {
    emits("csstransitionend", e);
  });
};

// 清除
const clear = () => {
  style.transition = "none";
};

// 触发
const trigger = () => {
  clear();
  // switch (props.name) {
  //   default:
  //     delete style.transformOrigin; // default: "center" | "50% 50%"
  //     delete style.backfaceVisibility;
  //     parentStyle.overflow = "hidden";
  //     break;
  // }
  style.transition = `all ${props.duration}ms ${props.timingFunction} ${props.delay}ms`;
};

onUnmounted(() => {
  s1?.unsubscribe();
  s2?.unsubscribe();
});

defineExpose({ trigger, clear });
</script>

<template>
  <Box
    class="css-transition"
    :class="props.name"
    display-type="empty"
    :style="style"
    @mount="mount"
  >
    <slot></slot>
  </Box>
</template>

<style>
@import "../../../../../css/animate_ce.css";
</style>
